/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SearchSource } from '../models/search-source';
import { Report } from '../models/report';
@Injectable({
  providedIn: 'root',
})
class ReportService extends __BaseService {
  static readonly ReportGetReportPath = '/api/Report';
  static readonly ReportSearchPath = '/api/Report/Search/{customerId}/{searchSize}/{pageIndex}/{includeAlarms}/{filterOld}';
  static readonly ReportGetDataPath = '/api/Report/GetData/{customerId}/{siteUri}/{period}/{timeZoneOffset}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param fileId undefined
   */
  ReportGetReportResponse(fileId?: null | string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (fileId != null) __params = __params.set('fileId', fileId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Report`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param fileId undefined
   */
  ReportGetReport(fileId?: null | string): __Observable<string> {
    return this.ReportGetReportResponse(fileId).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `ReportService.ReportSearchParams` containing the following parameters:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `includeAlarms`:
   *
   * - `filterOld`:
   *
   * - `customerId`:
   *
   * - `type`:
   *
   * - `search`:
   */
  ReportSearchResponse(params: ReportService.ReportSearchParams): __Observable<__StrictHttpResponse<Array<SearchSource>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;





    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.search != null) __params = __params.set('search', params.search.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Report/Search/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.searchSize))}/${encodeURIComponent(String(params.pageIndex))}/${encodeURIComponent(String(params.includeAlarms))}/${encodeURIComponent(String(params.filterOld))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SearchSource>>;
      })
    );
  }
  /**
   * @param params The `ReportService.ReportSearchParams` containing the following parameters:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `includeAlarms`:
   *
   * - `filterOld`:
   *
   * - `customerId`:
   *
   * - `type`:
   *
   * - `search`:
   */
  ReportSearch(params: ReportService.ReportSearchParams): __Observable<Array<SearchSource>> {
    return this.ReportSearchResponse(params).pipe(
      __map(_r => _r.body as Array<SearchSource>)
    );
  }

  /**
   * @param params The `ReportService.ReportGetDataParams` containing the following parameters:
   *
   * - `timeZoneOffset`:
   *
   * - `siteUri`:
   *
   * - `period`:
   *
   * - `customerId`:
   */
  ReportGetDataResponse(params: ReportService.ReportGetDataParams): __Observable<__StrictHttpResponse<Array<Report>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;




    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Report/GetData/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteUri))}/${encodeURIComponent(String(params.period))}/${encodeURIComponent(String(params.timeZoneOffset))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Report>>;
      })
    );
  }
  /**
   * @param params The `ReportService.ReportGetDataParams` containing the following parameters:
   *
   * - `timeZoneOffset`:
   *
   * - `siteUri`:
   *
   * - `period`:
   *
   * - `customerId`:
   */
  ReportGetData(params: ReportService.ReportGetDataParams): __Observable<Array<Report>> {
    return this.ReportGetDataResponse(params).pipe(
      __map(_r => _r.body as Array<Report>)
    );
  }
}

module ReportService {

  /**
   * Parameters for ReportSearch
   */
  export interface ReportSearchParams {
    searchSize: number;
    pageIndex: number;
    includeAlarms: boolean;
    filterOld: boolean;
    customerId: number;
    type?: null | string;
    search?: null | string;
  }

  /**
   * Parameters for ReportGetData
   */
  export interface ReportGetDataParams {
    timeZoneOffset: number;
    siteUri: string;
    period: string;
    customerId: number;
  }
}

export { ReportService }
